
import React from "react";
import { DetailedHTMLProps, FC, SVGProps } from "react";
export const CancelOrderIcon: FC<
DetailedHTMLProps<SVGProps<SVGSVGElement>, SVGSVGElement>
> = ({className}) => (

    <svg className={className} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.0575 1.50012L12.3712 12.8138M12.3712 1.50012L6.71436 7.15697L1.0575 12.8138" stroke="black" stroke-width="2" stroke-linecap="round"/>
    </svg>
)